import { useState, useEffect } from "react";
import axios from "axios";
import { baseUrl, USER_ENDPOINT_BASE_URL } from "../../../../constants";

type Option = {
  label: string;
  value: string;
};

export type SettingsData = {
  catalogId: string;
  projects: Option[];
  regions: (Option & {
    complianceDetails: string;
  })[];
  services: (Option & {
    region: string;
  })[];
  instances: (Option & {
    region: string;
  })[];
  version: "1.0";
  serviceId: string;
  projectId: string;
};

const getRegions = (regions) => {
  return Object.keys(regions).map((r) => ({
    label: r.toUpperCase(),
    value: r,
    complianceDetails: regions[r].regionDetails,
  }));
};
const getProjects = (projects) => {
  return projects.map((project) => ({
    label: project.name,
    value: project.projectId,
  }));
};
const getInstances = (instances) => {
  const addSpacesToTitleCase = (str) => {
    // Add a space before each uppercase letter
    return str.replace(/([a-z])([A-Z])/g, "$1 $2");
  };
  return instances.map((instance) => {
    return {
      label: instance.instanceName,
      value: instance.instanceId,
      region: addSpacesToTitleCase(instance.region).toUpperCase(),
    };
  });
};

// baseUrl needs to be replaced by https://ssce-dev-cl01.ssnc-corp.cloud in local environments for these API's to work
// You can also simply just uncomment the line below "baseUrl" and USER_ENDPOINT_BASE_URL and it should work
// The API doesn't work for localhost:3000 endpoints yet

export const useCreateWorkflowViewer = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [settingsData, setSettingsData] = useState<SettingsData>();

  useEffect(() => {
    setIsLoading(true);
    const getInstancesCall = axios.get(
      `${baseUrl}/api/mktplc-catalog-api/v0/public/solutions/SSCE Performance Service Workflow - Stage 1/services/all/instances?version=1.0`,
    );
    const getRegionsCall = axios.get(
      `${baseUrl}d/api/mktplc-catalog-api/v0/public/solutions/SS&C%20Performance%20Service%20Workflow?context=solutionInfo&version=1.0`,
      // `https://ssce-dev-cl01.ssnc-corp.cloud/api/mktplc-catalog-api/v0/public/solutions/SS&C%20Performance%20Service%20Workflow?context=solutionInfo&version=1.0`,
    );
    const getProjectsCall = axios.get(
      `${USER_ENDPOINT_BASE_URL}/users/api/mktplc-user-management/v0/projects`,
      // `https://ssce-dm-kc-stg2l-marketplace-lb01.ssnc-corp.cloud/users/api/mktplc-user-management/v0/projects`,
    );
    Promise.all([getProjectsCall, getRegionsCall, getInstancesCall])
      .then(([{ data: projects }, { data: regions }, { data: instances }]) => {
        setIsLoading(false);
        setHasError(false);
        setSettingsData({
          version: "1.0",
          serviceId: regions.solutionId,
          projectId: "",
          catalogId: regions.catalogId,
          regions: getRegions(regions.regions),
          projects: getProjects(projects.projects),
          instances: getInstances(instances.data_mesh_platform),
          services: getInstances(instances.arr_performance),
        });
      })
      .catch(() => {
        setIsLoading(false);
        setHasError(true);
      });
  }, []);

  const createWorkflow = async (workflowData) => {
    const request = {
      instanceName: workflowData.settings.name,
      version: "1.0",
      projectId: workflowData.settings.project,
      catalogId: workflowData.catalogId,
      region: workflowData.settings.region,
      settings: {
        services: {
          arr_performance: {
            instanceId: workflowData.settings.algoReport,
          },
          data_mesh_platform: {
            instanceId: workflowData.settings.datameshInstance,
          },
        },
      },
    };
    setIsLoading(true);
    return axios
      .post(
        `${baseUrl}/api/mktplc-catalog-api/v0/public/solutions/provision/SS&C Performance Service Workflow`,
        // "https://ssce-dev-cl01.ssnc-corp.cloud/api/mktplc-catalog-api/v0/public/solutions/provision/SS&C Performance Service Workflow",
        request,
      )
      .then(() => {
        setIsLoading(false);
        setHasError(false);
      })
      .catch(() => {
        setHasError(true);
        throw new Error();
      });
  };

  return { isLoading, hasError, settingsData, createWorkflow };
};
